import Gateway from '@/utils/Gateway';
// import { hasPackage } from '@/utils/package';

export function getContactConfigPage() {
    return new Promise(resolve => {
        // 企微完整版上线后会去掉微信客服页面
        resolve('/mng/weworkAccount/index');
        // let contactPageUrl = '/mng/account/wework/wxkf#/';

        // if (hasPackage('10061')) {
        //     resolve(contactPageUrl);
        // } else {
        //     Gateway.get('/v1/account/privileges')
        //         .then(data => {
        //             const { adminPrivileges } = data || {};

        //             if (adminPrivileges && adminPrivileges.length) {
        //                 adminPrivileges.some(privKey => {
        //                     if (privKey === 146) {
        //                         contactPageUrl = '/mng/weworkAccount/index#/contact';
        //                         return true;
        //                     }

        //                     return false;
        //                 });
        //             }

        //             resolve(contactPageUrl);
        //         })
        //         .catch(() => {
        //             resolve(contactPageUrl);
        //         });
        // }
    });
}

export function getWxkfVersion() {
    // 获取不到version值显示购买引导页
    // wxkf_united_robot：微信客服（机器人）联合版
    // wxkf_standalone_web：微信客服（web）独立版
    // wxkf_standalone_pc：微信客服（pc）独立版
    return Gateway.get('/v1/basic/corp/wework/WxkfVersion').then(data => {
        const { version } = data || {};
        let wxkfVersion = '';

        if (version === 'wxkf_united_robot') {
            wxkfVersion = 'robot';
        } else if (version === 'wxkf_standalone_web') {
            wxkfVersion = 'web';
        } else if (version === 'wxkf_standalone_pc') {
            wxkfVersion = 'pc';
        }

        return wxkfVersion;
    });
}
